$(function () {

    // Define variables
    const collectionProviderURL = $.p("collectionProvider", "home");
    const singleProviderURL = $.p("singleProvider", "home");
    const regionProviderURL = $.p("regionCollectionProvider", "home");
    const cityProviderURL = $.p("cityCollectionProvider", "home");
    const pointProviderURL = $.p("pointCollectionProvider", "home");
    const nearestBoundsProviderURL = $.p("nearestBoundsProvider", "home");
    const cityAutocompleteProviderURL = $.p("cityAutocompleteProvider", "home");
    const markerIconURL = $.p("markerIcon", "home");

    // Translation
    const chooseProvinceTranslation = $.p("chooseProvinceTranslation", "home");
    const chooseCityTranslation = $.p("chooseCityTranslation", "home");
    const showOnMapTranslation = $.p("showOnMapTranslation", "home");
    const noNearPointsTranslation = $.p("noNearPointsTranslation", "home");
    const errorLocateTranslation = $.p("errorLocateTranslation", "home");

    let mapGenerated = false;

    $("#salePointsContainer").waypoint({
        handler: function () {
            if (!mapGenerated) {
                mapGenerated = true;

                const pointsMap = $("#mapContainer").pointsMapPlugin({
                    searchInput: $("#searchInput"),
                    onlinePositionButton: $("#onlinePositionButton"),
                    singleTemplate: "condensed",
                    markerConfig: {
                        iconURL: markerIconURL,
                        iconSize: [25, 32]
                    },
                    dataProvider: {
                        collectionProviderURL: collectionProviderURL,
                        singleProviderURL: singleProviderURL,
                        regionProviderURL: regionProviderURL,
                        cityProviderURL: cityProviderURL,
                        pointProviderURL: pointProviderURL,
                        nearestBoundsProviderURL: nearestBoundsProviderURL,
                        cityAutocompleteProviderURL: cityAutocompleteProviderURL
                    },
                    container: {
                        regionChoice: $("#regionChoice"),
                        cityChoice: $("#cityChoice"),
                        pointChoice: $("#pointChoice"),
                        pointDetails: $("*[data-point-details]")
                    },
                    translation: {
                        "Please choose a province": chooseProvinceTranslation,
                        "Please choose a city": chooseCityTranslation,
                        "Show on the map": showOnMapTranslation,
                        "Unfortunately, there are no points near your location": noNearPointsTranslation,
                        "Unfortunately, we can not determine your location": errorLocateTranslation
                    }
                });

                $(".btn-choice-active").bind("click", function () {
                    const onlyActive = $(this).hasClass("choice-active");
                    let hideTemporaryClosed = false;

                    // var status = $(this).hasClass("active");
                    // status ? $(this).removeClass("active") : $(this).addClass("active");

                    if (onlyActive) {
                        hideTemporaryClosed = true;
                        $(".btn-choice-active").removeClass("active");
                        $(".btn-choice-active.choice-active").addClass("active");
                    } else {
                        hideTemporaryClosed = false;
                        $(".btn-choice-active").removeClass("active");
                        $(".btn-choice-active.choice-all").addClass("active");
                    }

                    pointsMap.reloadMarkers({
                        hideTemporaryClosed: hideTemporaryClosed
                    });
                });
            }
        }
    });

    const reviewSwiper = new Swiper(".reviewSwiper", {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30
            }
        },
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
});

//# sourceMappingURL=home.js.map
